import { z } from "zod";
import { isSupportedLogo } from "../../utils/logo";

// the game renders colors as-is; anything the picker didn't produce (free-typed "blue", "#ab") breaks it silently.
// 6 digits only: the mystery game's newShade() bails out below 7 chars, so "#fff" renders the box unshaded/flat.
const hexColor = z.string().regex(/^(#[0-9a-fA-F]{6})?$/, "errors.colors.invalid");

export const promoCodeSchema = z.object({
  id: z.string(),
  giftId: z.string(),
  value: z.string(),
  expiracyDate: z.string().nullable(),
  used: z.boolean(),
  deleted: z.boolean().optional(),
});

// the three fields the add/edit dialog collects; `id`, `used` and `deleted` are owned by the table
export const promoCodeEntrySchema = promoCodeSchema
  .pick({ giftId: true, value: true, expiracyDate: true })
  .extend({
    giftId: z.string().min(1, "errors.promoCodes.giftRequired"),
    value: z.string().trim().min(1, "errors.promoCodes.valueRequired"),
  });

export type PromoCodeEntryValues = z.infer<typeof promoCodeEntrySchema>;

export const campaignFormSchema = z.object({
  label: z.string(),
  game: z.enum(["WHEEL", "GIFTBOX", "SLOT", "CARDS"]),
  primaryColor: hexColor,
  secondaryColor: hexColor,
  logo: z.string(),
  logoUri: z.string().refine((v) => !v || isSupportedLogo(v), "errors.logo.format"),
  startDate: z.string().optional(),
  isDisabled: z.boolean(),
  profile: z.enum(["PREMIUM", "BOOSTER"]),
  theme: z.string(),
  kioskMode: z.boolean(),
  skipCooldown: z.boolean(),
  controlledReviews: z.boolean(),
  voucherStart: z.number().int().min(0),
  voucherExpiration: z.number().int().min(1).nullable(),
  promoCodes: z.array(promoCodeSchema),
});

export type CampaignFormValues = z.infer<typeof campaignFormSchema>;
